'use client'

import { PaymentCouponSelectorStatus } from '@features/payment/model'
import { useTranslation } from '@shared/config/i18n'
import { memo } from 'react'
import { match } from 'ts-pattern'

import { BottomSheetTrigger, HStack, Line24pxDownIcon, Typography } from '@podo-app/design-system-temp'

type Props = (
  | {
      status: Extract<PaymentCouponSelectorStatus, 'EMPTY_COUPON'>
    }
  | {
      status: Extract<PaymentCouponSelectorStatus, 'NON_SELECT'>
      availableCouponsCount: number
    }
  | {
      status: Extract<PaymentCouponSelectorStatus, 'SELECTED_COUPON'>
      selectedCouponTitle: string
    }
) & { emptyMessage?: string }

const PaymentCouponSelector = memo((props: Props) => {
  const t = useTranslation()

  return (
    <HStack
      as={BottomSheetTrigger}
      className="px-4 py-3.5 h-[52px] items-center justify-between border rounded-lg border-gray-200"
    >
      {match(props)
        .with({ status: 'EMPTY_COUPON' }, () => (
          <Typography size="body1" className="text-gray-400">
            {props.emptyMessage ?? t('payment.coupon.empty')}
          </Typography>
        ))
        .with({ status: 'NON_SELECT' }, ({ availableCouponsCount }) => (
          <Typography size="body1">{t('payment.coupon.available', { count: availableCouponsCount })}</Typography>
        ))
        .with({ status: 'SELECTED_COUPON' }, ({ selectedCouponTitle }) => (
          <Typography size="body1">{selectedCouponTitle}</Typography>
        ))
        .otherwise(() => null)}

      <Line24pxDownIcon className="text-gray-500" />
    </HStack>
  )
})

export default PaymentCouponSelector
